/**
 * Module dependencies.
 */

import { Market } from 'src/types/markets';
import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
  slug: string;
};

/**
 * Export `fetchMarket`.
 */

export async function fetchMarket({ locale, slug }: Query): Promise<Market> {
  const endpoint = getApiEndpoint('getMarket', { slug });

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
